// extracted by mini-css-extract-plugin
export var alertIcon = "_tg-0";